import { zetApi } from '@zet/network'

import { IFilterDto, IScratchCard, ScratchCardItem } from './types'

const getFilterDto = (filterDto: IFilterDto) => {
  return encodeURIComponent(JSON.stringify(filterDto))
}

export async function getScratchCardList(offset: number) {
  offset = offset || 0
  const { data } = await zetApi.get<IScratchCard>(
    `/scratchCard/list/v2?offset=${offset}&limit=10&filterDto=${getFilterDto({
      pagination: {
        offset: offset,
        limit: 10,
      },
      sort: {
        order: 'descend',
        key: 'created_at',
      },
    })}`
  )

  return {
    nextOffset: offset + 10,
    scratchCards: data?.data?.scratchCards?.filter(
      (scratchCard: ScratchCardItem) => scratchCard.isRead
    ),
    total: data?.data?.total || 0,
    totalEarnings: data?.data?.totalEarnings || 0,
  }
}

export async function onScratchCardReveal(scratchCardId: number) {
  const { data } = await zetApi.post(
    `scratchCard/open/v2?scratchCardId=${scratchCardId}`
  )

  return data
}
